<template>
  <div class="map-view">
    <!-- <el-select v-model="type" placeholder="切换场地" class="map-view-select" @change="getList">
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
        </el-select> -->
    <div class="chart-wrapper">
      <div class="china-chart" ref="ChinaChart"></div>
      <div class="map-view-holder"></div>
    </div>
  </div>
</template>
<script>
import * as echarts from "echarts/lib/echarts.js";
import "echarts/lib/component/geo";
import "echarts/lib/component/tooltip";
import "echarts/lib/chart/scatter";
import "echarts/lib/chart/effectScatter";
import "echarts/lib/chart/map";
import provinceLocation from "../../../api/province.js";
import cityMap from "@/utils/china.json";
echarts.registerMap("china", cityMap);

export default {
  components: {},
  emit: ["changeMapSel", "clickMapSel"],
  data() {
    return {
      options: [
        {
          label: "场地",
          value: 0,
        },
        {
          label: "步道",
          value: 1,
        },
      ],
      allData: [],
      myChart: null,
      defaultHighlight: true,
    };
  },
  methods: {
    drawImg() {
      this.myChart = echarts.init(this.$refs.ChinaChart);
      let option = {
        tooltip: {
          trigger: "item",
          backgroundColor: "#fff",
          borderColor: "#F2F2F2",
          textStyle: {
            color: "#666",
            fontSize: 12,
          },
          // formatter(params) {
          //   let htmlStr = `
          //                 <div style='font-size:18px;'> ${params.name}</div>
          //               `;
          //   return htmlStr;
          // },
          formatter: function (params) {
            if (typeof params.value[2] == "undefined") {
              return null; //params.name + ' : ' + params.value;
            } else {
              return `<div class="map-chart-tooltip">${params.name} : ${
                params.value[2]
              }${params.value[3] ? "条步道" : "个场地"}</div>`;
            }
          },
        },
        geo: {
          map: "china",
          show: true,
          roam: false,
          label: {
            normal: {
              show: false,
            },
            emphasis: {
              show: false,
            },
          },
          scaleLimit: {
            min: 1,
            max: 1,
          },
          layoutCenter: ["50%", "50%"],
          // 如果宽高比大于 1 则宽度为 100，如果小于 1 则高度为 100，保证了不超过 100x100 的区域
          // layoutSize: '100%',
          left: 0,
          right: 0,
          itemStyle: {
            normal: {
              areaColor: "#F0F0F0",
              borderColor: "#fff", //线
              shadowColor: "#fff", //外发光
              shadowBlur: 2,
            },
            emphasis: {
              areaColor: "#F0F0F0", //悬浮区背景
            },
          },
        },
        series: [
          {
            type: "map",
            map: "china",
            geoIndex: 0,
            aspectScale: 0.75, //长宽比
            showLegendSymbol: false, // 存在legend时显示
            roam: false,
            animation: false,

            // data: data
          },
          {
            id: "point",
            type: "effectScatter",
            data: this.allData,
            coordinateSystem: "geo",
            zlevel: 4,
            symbolSize: 5,
            showEffectOn: "emphasis",
            itemStyle: {
              normal: {
                color: "#F43425",
              },
            },
            cursor: "pointer",
            rippleEffect: {
              scale: 8,
              brushType: "fill",
              number: 1,
            },
          },
        ],
      };
      this.myChart.setOption(option);
    },
    setData(data, type) {
      if (!data.length) {
        this.myChart.setOption({
          series: {
            id: "point",
            data: [],
          },
        });
        return false;
      }
      let mapData = [];
      const _this = this;

      data.forEach((i, index) => {
        if (i.province && i.top4.length) {
          
          const p = i.top4[0];
          if (!p.longitude || !p.latitude) {
            let key = p.province;
            if(key == "北京" || key == "上海" || key == "重庆" || key == "天津"){
              key += "市"
            }
            var candidate = provinceLocation.filter((item) => {
              return item.name == key;
            });
          
            var local = candidate[0].center;
            if(local){
            var longitude = local.split(",")[0];
            var latitude = local.split(",")[1];
            p.longitude = longitude;
            p.latitude = latitude;
            }
          }
          mapData.push({
            name: i.province,
            value: [p.longitude, p.latitude, i.totalCount, type],
          });
        }
      });
      console.log("this.myChart.setOption mapData", mapData);
      this.myChart.setOption({
        series: {
          id: "point",
          data: mapData,
        },
      });
      this.myChart.on("mouseover", function (params) {
        if (params.seriesType == "effectScatter") {
          _this.dataIndex = params.dataIndex;
          if (_this.defaultHighlight) {
            _this.myChart.dispatchAction({
              type: "downplay",
              seriesIndex: 1,
              dataIndex: 0,
            });
            _this.defaultHighlight = false;
          }
          _this.$emit("changeMapSel", params.dataIndex);
        }
      });
      this.myChart.on("click", function (params) {
        if (params.seriesType == "effectScatter") {
          _this.$emit("clickMapSel", params.dataIndex);
        }
      });
      //默认选择第一个
      setTimeout(() => {
        this.myChart.dispatchAction({
          type: "highlight",
          seriesIndex: 1,
          dataIndex: 0,
        });
        this.myChart.dispatchAction({
          type: "showTip",
          seriesIndex: 1,
          dataIndex: 0,
        });
      }, 1000);
    },
  },
  mounted() {
    this.drawImg();
  },
};
</script>
<style lang="scss" scoped>
.map-view {
  margin-bottom: 14px;
  .chart-wrapper {
    position: relative;
    width: 100%;
    .map-view-holder {
      padding-top: 77%;
      width: 100%;
    }
    .china-chart {
      // height: 467px;
      display: inline-block;
      position: absolute;
      left: 30px;
      right: 30px;
      height: 100%;
    }
  }
}
@media screen and (max-width: 960px) {
  .map-view .chart-wrapper .china-chart {
    left: 0;
    right: 0;
    div {
      width: 100%;
      height: 100%;
    }
  }
}
</style>